import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../services/api/axios.config';
import { notify } from '../utils/methods/notification';

const initialState = {
    isLoading: false,
    error: false,
    errorMessage: "",
    errorType: "",
};


// fetch the all fetchQueryList list 
export const fetchQueryList = createAsyncThunk(
    'bmr/fetchQueryList',
    async (id, { rejectWithValue }) => {
        try {
            const response = await api.get(`/query-field-details/${id}`);
            return response?.data;
        } catch (error) {
            return rejectWithValue(error?.response ? error?.response?.data : error?.message);
        }
    }
);

// raisedQuery 
export const raisedQuery = createAsyncThunk(
    'bmr/raisedQuery',
    async (args, { rejectWithValue, dispatch }) => {
        try {
            const { prescreening_id, patient_id, data, field_id } = args
            const response = await api.post(`/raised-query/${prescreening_id}/${patient_id}/${field_id}`, data);
            notify.success(response?.data?.message);
            return response?.data;
        } catch (error) {
            dispatch(setQueryErrorMessege(error || error?.message || error?.response || error?.response?.data))
            return rejectWithValue(error?.response ? error?.response?.data : error?.message);
        }
    }
);
// rejectQuery 
export const rejectQuery = createAsyncThunk(
    'bmr/rejectQuery',
    async (id, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.patch(`/reject-query/${id}`);
            notify.success(response?.data?.message);
            return response?.data;
        } catch (error) {
            dispatch(setQueryErrorMessege(error || error?.message || error?.response || error?.response?.data))
            return rejectWithValue(error?.response ? error?.response?.data : error?.message);
        }
    }
);
// resolvedQuery 
export const resolvedQuery = createAsyncThunk(
    'bmr/resolvedQuery',
    async (args, { rejectWithValue, dispatch }) => {
        try {
            const { id, data } = args
            const response = await api.post(`/resolve-query/${id}`, data);
            notify.success(response?.data?.message);
            return response?.data;
        } catch (error) {
           dispatch(setQueryErrorMessege(error?.message || error?.response || error?.response?.data || error))
           return rejectWithValue(error?.response ? error?.response?.data : error?.message ? error?.message : error);
        }
    }
);
// add chata 
export const queryChat = createAsyncThunk(
    'bmr/queryChat',
    async (args, { rejectWithValue, dispatch }) => {
        try {
            const { id, data } = args
            const response = await api.post(`/prescreening-query-chat/${id}`, data);
            notify.success(response?.data?.message);
            return response?.data;
        } catch (error) {
            dispatch(setQueryErrorMessege(error?.message || error?.response || error?.response?.data || error))
           return rejectWithValue(error?.response ? error?.response?.data : error?.message ? error?.message : error);
        }
    }
);



// fetch the all fetchQuery History list 
export const fetchQueryHistory = createAsyncThunk(
    'bmr/fetchQueryHistory',
    async (id, { rejectWithValue }) => {
        try {
            const response = await api.get(`/prescreening-query-history/${id}`);
            return response?.data;
        } catch (error) {
           return rejectWithValue(error?.response ? error?.response?.data : error?.message ? error?.message : error);
         }
    }
);

export const fetchQueryHistoryForCoa = createAsyncThunk(
    'bmr/fetchQueryHistoryForCoa',
    async (id, { rejectWithValue }) => {
        try {
            const response = await api.get(`/prescreening-query-history/${id}?type=3`);
            return response?.data;
        } catch (error) {
            notify.error(error)
           return rejectWithValue(error?.response ? error?.response?.data : error?.message ? error?.message : error);
               }
    }
);

const bmrQueryPreScreenSlice = createSlice({
    name: 'bmrQueryPreScreen',
    initialState,
    reducers: {
        clearQueryErrorMessege(state) {
            state.errorMessage = ""
            state.errorType = ""
            state.error = false
        },
        setQueryErrorMessege(state, action) {
            state.error = true
            state.errorMessage = action.payload
            state.errorType = "error"
        },
    },
    extraReducers: (builder) => {
        /// handle fetch all field query list list
        builder
            .addCase(fetchQueryList.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchQueryList.fulfilled, (state) => {
                state.isLoading = false;
            })
            .addCase(fetchQueryList.rejected, (state) => {
                state.isLoading = false;
            });
        /// handle fetch all field query history list
        builder
            .addCase(fetchQueryHistory.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchQueryHistory.fulfilled, (state) => {
                state.isLoading = false;
            })
            .addCase(fetchQueryHistory.rejected, (state) => {
                state.isLoading = false;
            });
            
                builder
            .addCase(fetchQueryHistoryForCoa.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchQueryHistoryForCoa.fulfilled, (state) => {
                state.isLoading = false;
            })
            .addCase(fetchQueryHistoryForCoa.rejected, (state) => {
                state.isLoading = false;
            });
        builder
            .addCase(raisedQuery.pending, (state) => {
                state.isLoading = false;
            })
            .addCase(raisedQuery.fulfilled, (state, action) => {
                state.isLoading = false;
                state.errorMessage = action?.payload?.message
                state.errorType = "success"
                state.error = true
            })
            .addCase(raisedQuery.rejected, (state, action) => {
                state.isLoading = false;
                state.errorMessage = action?.payload?.message;
                state.errorType = "error"
                state.error = true
            });
        builder
            .addCase(rejectQuery.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(rejectQuery.fulfilled, (state, action) => {
                state.isLoading = false;
                state.errorMessage = action?.payload?.message
                state.errorType = "success"
                state.error = true
            })
            .addCase(rejectQuery.rejected, (state, action) => {
                state.isLoading = false;
                state.errorMessage = action?.payload?.message;
                state.errorType = "error"
                state.error = true
            });
        builder
            .addCase(resolvedQuery.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(resolvedQuery.fulfilled, (state, action) => {
                state.isLoading = false;
                state.errorMessage = action?.payload?.message
                state.errorType = "success"
                state.error = true
            })
            .addCase(resolvedQuery.rejected, (state, action) => {
                state.isLoading = false;
                state.errorMessage = action?.payload?.message;
                state.errorType = "error"
                state.error = true
            });
        builder
            .addCase(queryChat.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(queryChat.fulfilled, (state, action) => {
                state.isLoading = false;
                state.errorMessage = action?.payload?.message
                state.errorType = "success"
                state.error = true
            })
            .addCase(queryChat.rejected, (state, action) => {
                state.isLoading = false;
                state.errorMessage = action?.payload?.message;
                state.errorType = "error"
                state.error = true
            });
    },
});
export const { clearQueryErrorMessege, setQueryErrorMessege } = bmrQueryPreScreenSlice.actions

export const selectQueryLoading = (state) => state.bmrQueryPreScreen.isLoading;
export const selectQueryErrorMessege = (state) => state.bmrQueryPreScreen.errorMessage;
export const selectQueryErrorType = (state) => state.bmrQueryPreScreen.errorType;
export const selectQueryError = (state) => state.bmrQueryPreScreen.error;








export default bmrQueryPreScreenSlice.reducer;
